var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "collapsible-container",
      class: { "collapsible-collapsed": _vm.collapsed }
    },
    [
      _c(
        "button",
        {
          staticClass: "collapsible-header",
          attrs: {
            title:
              "Click to " + (_vm.collapsed ? "expand" : "collapse") + " section"
          },
          on: {
            click: function($event) {
              return _vm.$emit("update:collapsed", !_vm.collapsed)
            }
          }
        },
        [
          _vm._v("\n\t\t" + _vm._s(_vm.header) + "\n\t\t"),
          _c("span", { staticClass: "collapsible-header-icon" }, [
            _c("i", {
              staticClass: "fas fa-chevron-up",
              attrs: { title: _vm.collapsed ? "Collapsed" : "Expanded" }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide" } }, [
        !_vm.collapsed
          ? _c(
              "div",
              { staticClass: "collapsible-content" },
              [_vm._t("default")],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }